module.exports = __webpack_public_path__ + "static/media/rec_point6.26e836a3.svg";